import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'CmgTryAgainModal'
})

export default class CmgTryAgainModal extends Vue {
    get sadAvocadoUrl(): string {
        return this.$appStore.state.cms.images.feedback.sadAvocado.default;
    }

    get onTryAgain(): () => Promise<void> {
        return this.$appStore.state.ui.modals.tryAgainModal.args!.onClickTryAgain;
    }

    async onClickTryAgain() {
        await this.onTryAgain();
        if(this.$appStore.state.reward.cyobRewards.length == 0) {
            return;
        }
        this.onClose();
    }

    get visible(): boolean {
        return this.$appStore.state.ui.modals.tryAgainModal.visible;
    }

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    onClose() {
        this.$services.ui.setModalVisibility('tryAgainModal', false);
    }
}
